import { ContentPage } from "@/components/marketing/ContentPage";
import { LegalDraftNotice } from "@/components/marketing/LegalDraftNotice";

export function Privacy() {
  return (
    <ContentPage kicker="Legal" title="Privacy Policy" lastUpdated="May 25, 2026">
      <LegalDraftNotice />

      <p>
        This Privacy Policy explains what information Notamen (the
        "Service") collects, how we use it, and the choices you have. It applies
        to people who use the Service and to visitors of our site.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li>
          <strong>Account information.</strong> When you're invited and create
          an account, we collect identifiers such as your email address, managed
          through Amazon Cognito.
        </li>
        <li>
          <strong>Brand and content data.</strong> The brand information,
          products or services, platform rules, and drafts you create and store
          in your workspace.
        </li>
        <li>
          <strong>Connected-account data.</strong> Tokens and identifiers needed
          to publish to the social platforms you connect (such as Instagram,
          Facebook, and TikTok).
        </li>
        <li>
          <strong>Usage and log data.</strong> Operational logs generated as you
          use the Service, used to run, secure, and debug it.
        </li>
      </ul>

      <h2>2. How we use information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>provide and operate the Service — generate drafts, run safety checks, schedule and publish approved posts;</li>
        <li>authenticate you and enforce workspace access controls;</li>
        <li>maintain security, prevent abuse, and troubleshoot issues; and</li>
        <li>communicate with you about your account and the Service.</li>
      </ul>

      <h2>3. How drafts are generated</h2>
      <p>
        To generate drafts, we send your brand information and your generation
        inputs to Anthropic's Claude models (via the Anthropic API and AWS
        Bedrock). This processing happens only to produce the drafts you
        request.
      </p>

      <h2>4. Sub-processors</h2>
      <p>We rely on the following third-party providers to operate the Service:</p>
      <dl>
        <dt>Amazon Web Services (AWS)</dt>
        <dd>
          Hosting, databases (DynamoDB), object storage (S3), authentication
          (Cognito), secrets management (SSM), and model inference (Bedrock).
          Data is hosted in the AWS us-east-1 region.
        </dd>
        <dt>Anthropic</dt>
        <dd>
          AI model provider used to generate draft content via the Anthropic
          API.
        </dd>
      </dl>
      <p>
        We'll update this list as our sub-processors change.
      </p>

      <h2>5. How we share information</h2>
      <p>
        We don't sell your personal information. We share information only with
        the sub-processors above to operate the Service, with the social
        platforms you choose to connect when you publish, and where required by
        law.
      </p>

      <h2>6. Data retention</h2>
      <p>
        We retain your account and workspace data for as long as your account is
        active or as needed to provide the Service. When you delete data or
        close your workspace, we delete or de-identify the associated data
        within a reasonable period, except where we're required to retain it by
        law.
      </p>

      <h2>7. Security</h2>
      <p>
        We use the safeguards described on our <a href="/security">security
        page</a>, including per-workspace data isolation, encryption at rest via
        AWS, secrets stored in SSM SecureStrings, and role-based access control
        enforced server-side.
      </p>

      <h2>8. Your rights and choices</h2>
      <p>
        Depending on where you live, you may have rights to access, correct,
        export, or delete your personal information, and to object to or
        restrict certain processing. To make a request, contact us using the
        details below. We may need to verify your identity before acting on a
        request.
      </p>

      <h2>9. Changes to this Policy</h2>
      <p>
        We may update this Policy from time to time. If we make material
        changes, we'll take reasonable steps to notify you, and we'll update the
        date at the top of this page.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions or privacy requests? Email{" "}
        <a href="mailto:privacy@socialmediamanager.pheonixapps.com">
          privacy@socialmediamanager.pheonixapps.com
        </a>
        .
      </p>
    </ContentPage>
  );
}

export default Privacy;
